module.exports = __webpack_public_path__ + "img/Warehouse Summary.cccfc1f0.svg";